import { useEffect } from 'react';

/**
 * Custom hook to set the page title
 * @param title - The page title (will be appended with " | Scubamail")
 * @param dependencies - Optional dependencies array for useEffect
 */
export const usePageTitle = (title: string, dependencies: any[] = []) => {
  useEffect(() => {
    document.title = `${title} | Scubamail`;
    
    // Cleanup: restore default title when component unmounts
    return () => {
      document.title = 'Scubamail';
    };
  }, [title, ...dependencies]);
};


